// The menu-test comments collapse: whether the block is folded away behind its strip.
//
// It is a report param like the rest of the block's state, so it opens on the stored one and is
// announced back for the shell to write down. An expanded block is the resting state, so it says
// nothing rather than storing a value.

import { useCallback, useEffect, useRef, useState } from 'react'

export default function useCommentsCollapsed({ param, onCollapsedChange } = {}) {
  const [collapsed, setCollapsed] = useState(() => Boolean(param))

  const held = useRef(collapsed)
  held.current = collapsed

  const onCollapsedChangeRef = useRef(onCollapsedChange)
  onCollapsedChangeRef.current = onCollapsedChange

  // the stored value moved outside the block: the URL, an undo, another view of the question
  const seeded = useRef(param)
  useEffect(() => {
    if (seeded.current === param) return
    seeded.current = param

    setCollapsed(Boolean(param))
  }, [param])

  const onToggle = useCallback(next => {
    if (Boolean(next) === held.current) return

    setCollapsed(Boolean(next))
    onCollapsedChangeRef.current?.(next || null)
  }, [])

  return { collapsed, onToggle }
}
